import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { serverError } from './../../../../core/models/messages';
import { EsnEvaluationService } from './../../../../core/services/esn-evaluation/esn-evaluation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-liste-evaluateurs',
  templateUrl: './liste-evaluateurs.component.html',
  styleUrls: ['./liste-evaluateurs.component.css'],
})
export class ListeEvaluateursComponent {
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listevaluateur: any;
  searchForm: FormGroup = this.createSearchForm();
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  id = this.activatedRoute.snapshot.params['id'];
  sortAttr = '';

  constructor(
    private formBuilder: FormBuilder,
    private evaluationservice: EsnEvaluationService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.getListevaluateur();
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    // let sort={sort:this.currentSortDirection,sortAttribute:item}
    // console.log("sort",sort)
    if (this.searchForm.value != '')
      this.listevaluateur = this.sortDataService.sortArray(
        this.listevaluateur,
        this.sortAttr,
        this.currentSortDirection
      );
    else this.getListevaluateur();
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchevaluateur();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListevaluateur();
      }
    }
  }
  getListevaluateur() {
    let dataPyload =
      this.sortAttr == ''
        ? { id: this.id, per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{
              id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.evaluationservice.getListevaluateurs(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listevaluateur = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list evaluateur', this.listevaluateur);
        }
      },
      error: (error: any) => {
        console.error('Error fetching list evaluateur: ', error);
      },
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: ['', data?.search],
    });
  }

  /* search */
  searchevaluateur() {
    console.log('bonjour');
    let valueForm = this.searchForm.value;

    let data = {
      // sort:this.currentSortDirection,

      search: valueForm.search,
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };
    console.log('data', data);

    console.log('search', data.search);
    this.evaluationservice.searchevaluateur(this.id, data.search).subscribe({
      next: (resSearch) => {
        if (this.currentPage > 1) {
          this.currentPage = 1;
          this.searchevaluateur();
          console.log('response search', resSearch);
          //  console.log("response search",resSearch)
          //  this.listevaluateur = resSearch
          //  console.log("status",resSearch.status)
        } else {
          this.listevaluateur = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
        }
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
      },
    });
  }
}
